import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Illustration extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 col-md-4 col-sm-6">
                      <img id="info0" width="100%" src={require('../../../Images/Daily_project/Illustration/Illus1.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-sm-0">
                      <img id="info1" width="100%" src={require('../../../Images/Daily_project/Illustration/Illus2.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-0">
                      <img id="info2" width="100%" src={require('../../../Images/Daily_project/Illustration/Illus3.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-4">
                      <img id="info3" width="100%" src={require('../../../Images/Daily_project/Illustration/Illus4.jpg')} alt="Case_studies_2" />
                    </div>
                </div>
            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">Project</p>
                <p>
                  <AnchorLink href="#info0" className="bullet">Grish</AnchorLink>
                  <br />
                  <AnchorLink href="#info1" className="bullet">Gandhi</AnchorLink>
                  <br />
                  <AnchorLink href="#info2" className="bullet">Rohiht</AnchorLink>
                  <br />
                  <AnchorLink href="#info3" className="bullet">Rabit</AnchorLink>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ai.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>

            </div>
                  
            </div>
    )
}
}